import { errorFromResponse, notifications } from '~/app/notifications'
import eventBus from '~/events/eventBus'
import eventDefinitions from '~/events/eventDefinitions'
import AppTitle from '@theme/components/atom/AppTitle'
import PageContact from '~/themes/base/components/content/PageContact'
import PageIntro from '~/themes/oknadverenamiru/components/shop/PageIntro'

export default {
  extends: PageContact,
  components: {
    AppTitle,
    PageIntro,
  },
  created() {
    this.CLASS_ELEMENT = 'col-24 pl-2 pl-md-3'
    this.CLASS_ELEMENTS_OUTSIDE_NO_LABEL = 'row'
    this.CLASS_LABEL = 'custom-col-form-label pl-2 pl-md-3 mb-0'
    this.CLASS_ROW = 'custom-form-group row mb-4'
  },
  data() {
    return {
      input: {
        email: '',
        name: '',
        question: '',
        terms: false,
      },
    }
  },
  methods: {
    async submit() {
      if (!(await this.foxentryFormSubmit('#PageContactForm'))) {
        return
      }
      if (!(await this.$validator.validate())) {
        notifications.danger(this.$validator.errors.items[0].msg)
        return
      }
      this.startLoading()
      try {
        const url = `${this.$env.STORE_URL}/api/v1/contact-form`
        const message = {
          name: this.input.name,
          email: this.input.email,
          text: this.input.question,
          terms: this.input.terms,
        }

        await this.$axios.$post(url, message)

        const user = this.$store && this.$store.state?.user?.userData ? this.$store.state.user.userData : null
        eventBus.$emit(eventDefinitions.FORM.SUBMIT, {
          form_id: 'page_contact_form',
          user: {
            user_id: user?.id,
            email: this.input.email,
          },
        })

        notifications.success(this.$t('PageContact.sentNotification'))

        this.input.name = ''
        this.input.email = ''
        this.input.question = ''
        this.input.terms = false
        this.$validator.reset()
      } catch (e) {
        errorFromResponse(e.response)
      }
      this.stopLoading()
    },
  },
}
